import { render } from "./dermatology_procedures.vue?vue&type=template&id=78b881dc&scoped=true"
import script from "./dermatology_procedures.vue?vue&type=script&lang=js"
export * from "./dermatology_procedures.vue?vue&type=script&lang=js"

import "./dermatology_procedures.vue?vue&type=style&index=0&id=78b881dc&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b881dc"]])

export default __exports__